<template>
    <div>
        <v-layout row wrap style="text-align: center; padding: 15px; background-color: #ffffff">
            <v-flex sm3>
                Renters Promised: {{ totalRenters }}
            </v-flex>
            <v-flex sm3>
                Essential: {{ tierTally.essential }}
            </v-flex>
            <v-flex sm3>
                Branded: {{ tierTally.branded }}
            </v-flex>
            <v-flex sm3>
                Enterprise: {{ tierTally.enterprise }}
            </v-flex>
        </v-layout>
        <v-card-title>
            Clients
            <v-btn small dark color="green" class="mr-4 ml-4 button-style" elevation="0" @click="addClientDialog = true">Add Client</v-btn>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn small dark color="#5D337C" class="mr-4 button-style" elevation="0" @click="focusFilter('happinessRating')">Mood Mode</v-btn>
            <v-btn small dark color="#5D337C" class="mr-4 button-style" elevation="0" @click="focusFilter('onboardingRatio')">Onboarding Mode</v-btn>
            <v-btn small dark color="#5D337C" class="mr-4 button-style" elevation="0" @click="focusFilter('managementRatio')">Management Mode</v-btn>
            <v-btn small dark class="mr-4 button-style" elevation="0" @click="clearFilter()">Clear Filter</v-btn>
            <v-text-field outlined dense v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table multi-sort dense :sort-by.sync="sortBy" :sort-desc="[false, false]" :headers="headers" :items="clients" :options="options" :search="search" :loading="loading" loading-text="Getting the client list... Don't be impatient...">
            <template v-slot:item.happinessRating="{ item }">
                <v-btn dark small block :color="getHappinessColor(item.happinessRating)" elevation="0">
                    <v-icon>
                        {{ getHappinessIcon(item.happinessRating) }}
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:item.onboardingRatio="{ item }">
                <v-progress-linear :value="item.onboardingRatio" :color="getColor(item.onboardingRatio)" height="28" :rounded="true"></v-progress-linear>
            </template>
            <template v-slot:item.managementRatio="{ item }">
                <v-progress-linear v-if="item.managementRatio >= 0" :value="item.managementRatio" :color="getColor(item.managementRatio)" height="28" :rounded="true"></v-progress-linear>
            </template>
            <template v-slot:item.mostRecentNoteAuthor="{ item }">
                {{ item.mostRecentNoteAuthor | truncate(12) }}
            </template>
             <template v-slot:item.action="{ item }">
                 <v-btn dark color="#5D337C" elevation="0" height="28" block class="my-2" @click="$router.push('/account-view/' + item.id)"><v-icon small color="white" dark>arrow_forward</v-icon></v-btn>
            </template>
        </v-data-table>
        <v-dialog v-model="addClientDialog" max-width="1000px">
            <AddClient @clicked="addClientDialog = false" />
        </v-dialog>
    </div>
</template>
<script>
import db from '../firebase/init.js'
import moment from 'moment'
import AddClient from '../components/AddClient.vue'
export default {
    name: 'Clients',
    components: {
        AddClient
    },
    data(){
        return {
            addClientDialog: false,
            search: '',
            loading: false,
            sortBy: ['onboardingRatio', 'managementRatio'],
            headers: [
                { text: 'Company', value: 'company', 'sortable?': true },
                { text: 'Mood', value: 'happinessRating' },
                { text: 'Onboarding', value: 'onboardingRatio' },
                { text: 'Management', value: 'managementRatio' },
                { text: 'Users', value: 'numberOfRenters' },
                { text: 'Last interaction', value: 'mostRecentNoteAuthor' },
                { text: 'View', value: 'action' }
            ],
            onboardingColor: 'warning',
            clients: [],
            options:{
                itemsPerPage: 100
            },
            totalRenters: 0,
            tierTally: {
                essential: 0,
                branded: 0,
                enterprise: 0
            }
        }
    },
    methods: {
        clearFilter () {
            this.sortBy = null
        },
        focusFilter (focus) {
            this.sortBy = [ `${ focus }` ]
        },
        getColor (ratio) {
            if (ratio < 50) return 'red'
            else if (ratio < 99) return 'orange'
            else if (ratio == 100) return 'green'
            else return '#f2f2f2'
        },
        getHappinessIcon (happinessRating) {
            if (happinessRating < 20) return 'sentiment_very_dissatisfied'
            else if (happinessRating < 40) return 'sentiment_dissatisfied'
            else if (happinessRating < 50) return 'sentiment_neutral'
            else if (happinessRating < 75) return 'sentiment_satisfied'
            else return 'sentiment_very_satisfied'
        },
        getHappinessColor (happinessRating) {
            if (happinessRating < 20) return 'red'
            else if (happinessRating < 40) return 'orange'
            else if (happinessRating < 50) return 'yellow'
            else if (happinessRating < 75) return 'blue'
            else return 'green'
        }
    },
    mounted(){
        document.title = "Vaboo Clients"
        this.loading = true
        firebase.firestore().collection('clients').onSnapshot(snapshot => {
            this.clients = []
            snapshot.forEach(doc => {
                var client = doc.data()
            // calculate the KPIS 
                if(doc.data().tierType == 'Essential'){
                    this.tierTally.essential ++
                }else if(doc.data().tierType == 'Branded'){
                    this.tierTally.branded ++
                }else{
                    this.tierTally.enterprise ++
                }
            // calculate onboarding tasks ratio
                let calc = Number(doc.data().completedOnboardingTasks / doc.data().totalOnboardingTasks * 100)
                if(calc == 0){
                    calc = 100
                }else if(doc.data().completedOnboardingTasks == 0){
                    calc = 0
                }
            // calculate management tasks ratio
                let calc2 = Number(doc.data().completedManagementTasks / doc.data().totalManagementTasks * 100)
                if(doc.data().completedManagementTasks == 0 && doc.data().totalManagementTasks == 0){
                    calc2 = 101
                }else if (doc.data().completedManagementTasks == 0){
                    calc2 = 0
                }else if(calc2 == 0){
                    calc2 = 100
                }
                client.mostRecentNoteTime = moment(Number(doc.data().mostRecentNoteTime)).format('llll')
                client.id = doc.id
                client.onboardingRatio = calc
                client.managementRatio = calc2
                this.totalRenters = Number(this.totalRenters) + Number(doc.data().numberOfRenters)
                this.clients.push(client)
            })
            this.loading = false
        })
    }
}
</script>

<style>

</style>